export default __webpack_public_path__ + "static/media/pantry1-afterE-2048w.d6e3d08d.avif";